/**
 * DISPLAY-ONLY machine identifier.
 *
 * Source of truth is the matched Mongo `machines` document (adaptDoc /
 * GetSearchData / loadMachines / myPlay machine enrichment).
 * Prefer `machines.slotNumber` when present and non-empty; otherwise `mnum`.
 *
 * Pass the matched machine record (or fields copied from that record by the
 * machines lookup, including adaptDoc-joined `slotNumber` on insight rows).
 *
 * NEVER use `floorLocation` or `slot_number` (floorLocation alias) for display —
 * those remain placement / map GeoJSON join keys only.
 *
 * Never use for API calls, selection, favorites, playlist, compare, or joins —
 * those keep using `mnum` / egmDetailId.
 */

export type MachineDisplaySource = {
  /** machines.slotNumber from the matched machines record. */
  slotNumber?: unknown;
  /** machines.mnum / insight join key. */
  mnum?: unknown;
  /** Ignored for display — placement only. */
  floorLocation?: unknown;
  /** Ignored for display — floorLocation alias. */
  slot_number?: unknown;
} | null | undefined;

const nonEmpty = (v: unknown): string => {
  if (v === null || v === undefined) return '';
  return String(v).trim();
};

/**
 * Display id from a matched machines record (or its fields).
 * Rule: machines.slotNumber if present (non-null/non-empty), else mnum.
 */
export function getMachineDisplayId(machine: MachineDisplaySource): string {
  if (!machine) return '';
  const fromSlotNumber = nonEmpty(machine.slotNumber);
  if (fromSlotNumber) return fromSlotNumber;
  return nonEmpty(machine.mnum);
}
